import React from "react";
import PropTypes from "prop-types";
import {
  Grid,
  TextField,
  MenuItem,
  Paper,
  Typography,
} from "@material-ui/core";
import useSharedStyles from "./SharedStyle";

const TransferDetails = ({ formData, handleChange, hintFormText ,disable }) => {
  const classes = useSharedStyles();

  const renderSelect = ({ name, label, options, required = false }) => (
    <>
      <Typography className={classes.label}>
        {label}
        {required && <span className={classes.requiredAsterisk}>*</span>}
      </Typography>
      <TextField
        select
        variant="outlined"
        size="small"
        fullWidth
        disabled={disable}
        id={name}
        name={name}
        value={formData[name] || ""}
        onChange={handleChange}
        required={required}
        className={classes.inputField} // optional, for compact styling
      >
        <MenuItem value="">
          <em>None</em>
        </MenuItem>
        {options.map((option) => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </TextField>
    </>
  );

  return (
    <Paper className={classes.paper} elevation={2}>
      <Typography variant="h6" className={classes.sectionTitle}>
        Transfer Details
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} md={3} style={{ display: "flex", flexDirection: "column", justifyContent: "flex-end" }}>
          <Typography className={classes.label}>
            Date of Transfer to IEPF
            <span className={classes.requiredAsterisk}>*</span>
          </Typography>
          <TextField
            size="small"
            variant="outlined"
            fullWidth
            id="transferDate"
            name="transferDate"
            type="date"
            value={formData.transferDate || ""}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
            required
            placeholder={hintFormText?.transferDate || ""}
            inputProps={{
              max: new Date().toISOString().split("T")[0],
            }}
            autoComplete="off"
        disabled={disable}

          />
        </Grid>

        <Grid item xs={12} md={3}>
          {renderSelect({
            name: "unclaimedSuspenseAccount",
            label: "Shares Transferred from Unclaimed Suspense Account",
            options: ["Yes", "No"],
            required: true,
          })}
        </Grid>

        <Grid item xs={12} md={3}>
          {renderSelect({
            name: "iepfRules",
            label: "Case Covered Under Rule 7 (8) & 7 (9) of IEPF Rules, 2016",
            options: ["Yes", "No"],
            required: true,
          })}
        </Grid>

        <Grid item xs={12} md={3} style={{ display: "flex", flexDirection: "column", justifyContent: "flex-end" }}>
          <Typography className={classes.label}>
            Claimable Amount
          </Typography>
          <TextField
            size="small"
            variant="outlined"
            fullWidth
            id="claimableAmount"
            name="claimableAmount"
            type="text"
            required
            value={formData.claimableAmount || ""}
            onChange={handleChange}
            placeholder={hintFormText?.claimableAmount || "Enter amount"}
            inputProps={{
              min: 0,
              step: "0.01"
            }}
            autoComplete="off"
        disabled={disable}

          />
        </Grid>
      </Grid>
    </Paper>
  );
};

TransferDetails.propTypes = {
  formData: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  hintFormText: PropTypes.object,
  disable: PropTypes.bool,
};

export default TransferDetails;